import { MetadataContext } from '@/context/MetadataContext';
import { useContext } from 'react';

export const useMetadata = () => useContext(MetadataContext);
